import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@decisiv/ui-components/lib/components/Avatar';
import Button from '@decisiv/ui-components/lib/components/Button';
import ExclamationCircle from '@decisiv/iconix/lib/components/ExclamationCircle';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { EXISTING_USER } from './copy';
import {
  EXISTING_USER_WARNING_COLOR,
  ExistingUserCardContainer,
  ExistingUserCardHeader,
  ExistingUserContent,
  ExistingUserIconBox,
  ExistingUserIdentity,
  ExistingUserIdentityRow,
  ExistingUserIdentityText,
  ExistingUserTextColumn,
} from './styles';

function ExistingUserCard({ existingUser, onAction, variant }) {
  const copy = EXISTING_USER[variant];
  const accountCount =
    variant === 'restore'
      ? existingUser.restoreAccountIds.length
      : existingUser.addAccountIds.length;
  const phone = existingUser.mobile
    ? existingUser.mobileCountryCode
       ? `+${existingUser.mobileCountryCode} ${existingUser.mobile}`
       : existingUser.mobile
    : null;

  return (
    <ExistingUserCardContainer role="alert">
      <ExistingUserIconBox>
        <ExclamationCircle color={EXISTING_USER_WARNING_COLOR} />
      </ExistingUserIconBox>

      <ExistingUserContent>
        <ExistingUserCardHeader>
          <ExistingUserTextColumn>
            <P weight="semibold" style={{ margin: 0 }}>
              {copy.title}
            </P>
            <P size="small" style={{ margin: 0 }}>
              {copy.description(accountCount)}
            </P>
          </ExistingUserTextColumn>
          <Button
            kind="primary"
            size="small"
            text={copy.action}
            onClick={onAction}
          />
        </ExistingUserCardHeader>

        <ExistingUserIdentity>
          <ExistingUserIdentityRow>
            <Avatar email={existingUser.email} name={existingUser.fullName} />
            <ExistingUserIdentityText>
              <P weight="semibold" style={{ margin: 0 }}>
                {existingUser.fullName}
                {existingUser.jobRole ? ` (${existingUser.jobRole})` : ''}
              </P>
              <P shade={1} size="small" style={{ margin: 0 }}>
                {[existingUser.email, phone].filter(Boolean).join(' · ')}
              </P>
            </ExistingUserIdentityText>
          </ExistingUserIdentityRow>
        </ExistingUserIdentity>
      </ExistingUserContent>
    </ExistingUserCardContainer>
  );
}

ExistingUserCard.propTypes = {
  existingUser: PropTypes.shape({
    addAccountIds: PropTypes.arrayOf(PropTypes.number),
    email: PropTypes.string,
    fullName: PropTypes.string,
    jobRole: PropTypes.string,
    mobile: PropTypes.string,
    mobileCountryCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    restoreAccountIds: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  onAction: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['restore', 'add']).isRequired,
};

export default ExistingUserCard;
